// extracted by mini-css-extract-plugin
export default {"container":"pages_container__IyM8T","modulesContainer":"pages_modulesContainer__VB0XN","startText":"pages_startText__aak68"};